import { useTranslation } from 'react-i18next'

import { PkgWarehouse } from '@/api/user-package/types/UserPkg'
import { TransKey } from '@/i18n'
import { cn } from '@/lib/utils'

import greeceFlagCircle from '../imgs/flags/greece-circle.png'
import uaeFlagCircle from '../imgs/flags/uae-circle.png'
import ukFlagCircle from '../imgs/flags/uk-circle.png'
import usaFlagCircle from '../imgs/flags/usa-circle.png'

const warehouseToLogo = {
  [PkgWarehouse.GR]: greeceFlagCircle,
  [PkgWarehouse.USA]: usaFlagCircle,
  [PkgWarehouse.UK]: ukFlagCircle,
  [PkgWarehouse.UAE]: uaeFlagCircle,
}
export const warehouseToTrans: Record<PkgWarehouse, TransKey> = {
  [PkgWarehouse.GR]: 'addresses.greece',
  [PkgWarehouse.USA]: 'addresses.usa',
  [PkgWarehouse.UK]: 'addresses.uk',
  [PkgWarehouse.UAE]: 'addresses.uae',
}
interface Props {
  warehouse: PkgWarehouse
  includeLabel?: boolean
  className?: string
  containerClassName?: string
}
export const WarehousePreview = ({ warehouse, includeLabel, className, containerClassName }: Props) => {
  const { t } = useTranslation()
  return (
    <div className={cn('flex items-center gap-2', containerClassName)}>
      <img src={warehouseToLogo[warehouse]} alt={warehouse} className={cn('size-4', className)} />
      {includeLabel && <span className='text-sm'>{t(warehouseToTrans[warehouse])}</span>}
    </div>
  )
}
